import { Controller } from 'react-hook-form'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { useMemo, useRef, useState } from 'react'
import { ImageDialog } from './ImageDialog'
import '../../utils/ImageBlot'
import { Box } from '@chakra-ui/react'

export function TextEditor({ control, imageSize = 100000, name, noImage = false, error, readOnly = false, ...props }) {
  const quillRef = useRef(null)
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const imageHandler = async () => {
    setIsDialogOpen(true)
  }

  const handleInsertImage = async (imageUrl, altText) => {
    const quillObj = quillRef.current.getEditor()
    console.log('Inserting image:', quillObj.selection.savedRange.index)

    quillObj.insertEmbed(quillObj.selection.savedRange.index, 'image', {
      src: imageUrl,
      alt: altText,
    })
  }

  const modules = useMemo(
    () => ({
      toolbar: readOnly
        ? false
        : {
            container: [
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['link', !noImage && 'image'],
              [{ align: [] }],
              ['emoji'], // Adicionando emoji à toolbar
            ],
            handlers: {
              image: imageHandler,
            },
          },
      keyboard: {
        bindings: {
          enter: {
            key: 13,
            handler: () => true, // Preserva caracteres especiais no enter
          },
        },
      },
    }),
    [noImage, readOnly]
  )

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'link',
    'image',
    'code-block',
    'emoji', // Adicionando emoji aos formatos permitidos
  ]

  return (
    <Box
      sx={{
        '.ql-toolbar': {
          borderColor: error ? 'red.500' : '#378BBF',
          borderTopRadius: 'md',
          display: readOnly ? 'none' : 'block',
        },
        '.ql-container': {
          borderColor: error ? 'red.500' : '#378BBF',
          borderBottomRadius: 'md',
          backgroundColor: 'white',
        },
        '.ql-editor': {
          minHeight: props.height ? props.height : '300px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', // Fonte que suporta emoji
        },
        '.ql-editor.ql-blank::before': {
          color: 'gray.400',
          fontStyle: 'normal',
        },
      }}
    >
      <Controller
        control={control}
        defaultValue=""
        name={name || 'content'}
        render={({ field }) => (
          <ReactQuill
            theme="snow"
            {...field}
            modules={modules}
            formats={formats}
            placeholder="Digite sua mensagem aqui..."
            ref={quillRef}
            readOnly={readOnly}
            preserveWhitespace={true} // Preserva espaços e caracteres especiais
          />
        )}
      />

      <ImageDialog imageSize={imageSize} isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)} onInsert={handleInsertImage} />
    </Box>
  )
}
